<template>
    <a class="btn"
       :class="classes"
       @click.prevent="$emit('click')">
        <i v-if="loading"
           class="fa-regular fa-spinner fa-spin" />
        <slot v-else></slot>
    </a>
</template>

<script>
export default {
    props: {
        size: {
            type: String,
            default: null,
        },
        color: {
            type: String,
            default: 'default',
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
    emits: [
        'click',
    ],

    computed: {
        classes() {
            return [
                this.size ? `btn-${this.size}` : null,
                this.color ? `btn-${this.color}` : null,
            ];
        },
    },
};
</script>
